import { randomCreatedDate } from "@mui/x-data-grid-generator";
import { format } from "date-fns";

export const userData = [
  {
    id: 1,
    employeecode: "EMP001",
    fullname: "John Doe",
    role: "user",
    email: "john.doe@company.com",
    gender: "male",
    dob: format(randomCreatedDate(), "dd/MM/yyyy"),
    designation: "Senior Manager",
    department: "hr",
    jobgrade: "G1"
  },
  // {
  //   id: 2,
  //   employeeCode: "EMP002",
  //   fullName: "Jane Smith",
  //   roleid: "user",
  //   email: "jane.smith@company.com",
  //   gender: "Female",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Software Engineer",
  //   department: "IT",
  //   jobGrade: "P2"
  // },
  // {
  //   id: 3,
  //   employeeCode: "EMP003",
  //   fullName: "Robert Johnson",
  //   roleid: "user",
  //   email: "robert.johnson@company.com",
  //   gender: "Male",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Business Analyst",
  //   department: "Finance",
  //   jobGrade: "P3"
  // },
  // {
  //   id: 4,
  //   employeeCode: "EMP004",
  //   fullName: "Emily Davis",
  //   roleid: "user",
  //   email: "emily.davis@company.com",
  //   gender: "Female",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "UI/UX Designer",
  //   department: "Creative",
  //   jobGrade: "P2"
  // },
  // {
  //   id: 5,
  //   employeeCode: "EMP005",
  //   fullName: "Michael Brown",
  //   roleid: "user",
  //   email: "michael.brown@company.com",
  //   gender: "Male",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "HR Manager",
  //   department: "Human Resources",
  //   jobGrade: "M2"
  // },
  // {
  //   id: 6,
  //   employeeCode: "EMP006",
  //   fullName: "Sarah Wilson",
  //   roleid: "missionCreator",
  //   email: "sarah.wilson@company.com",
  //   gender: "Female",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Senior Accountant",
  //   department: "Finance",
  //   jobGrade: "P4"
  // },
  // {
  //   id: 7,
  //   employeeCode: "EMP007",
  //   fullName: "David Lee",
  //   roleid: "user",
  //   email: "david.lee@company.com",
  //   gender: "Male",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Lead Developer",
  //   department: "IT",
  //   jobGrade: "P5"
  // },
  // {
  //   id: 8,
  //   employeeCode: "EMP008",
  //   fullName: "Jennifer Taylor",
  //   roleid: "user",
  //   email: "jennifer.taylor@company.com",
  //   gender: "Female",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Marketing Specialist",
  //   department: "Marketing",
  //   jobGrade: "P3"
  // },
  // {
  //   id: 9,
  //   employeeCode: "EMP009",
  //   fullName: "Thomas Anderson",
  //   roleid: "user",
  //   email: "thomas.anderson@company.com",
  //   gender: "Male",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Software Engineer",
  //   department: "IT",
  //   jobGrade: "P2"
  // },
  // {
  //   id: 10,
  //   employeeCode: "EMP010",
  //   fullName: "Lisa Wong",
  //   roleid: "missionCreator",
  //   email: "lisa.wong@company.com",
  //   gender: "Female",
  //   date: format(randomCreatedDate(), "dd/MM/yyyy"),
  //   designation: "Office Administrator",
  //   department: "Administration",
  //   jobGrade: "P1"
  // }
  ];